import { motion } from 'framer-motion';

const KineticText = ({ lines, className = '', lineClassName = '', delay = 0.2 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => {
      const item = typeof line === 'string' ? { text: line } : line;
      return (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${item.accent ? 'text-brand-gradient' : ''} ${lineClassName}`}
            initial={{ y: '112%' }}
            animate={{ y: '0%' }}
            transition={{ duration: 0.9, delay: delay + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
          >
            {item.text}
          </motion.span>
        </span>
      );
    })}
  </span>
);

export default KineticText;
